import classNames from 'classnames'
import { FC, ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations'
import { TReplaceOptions } from 'cng-common/features/translations/components/translation/models/replaceOptions'
import { Flex } from 'core-components/library/flex'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './MdfOverviewCard.module.scss'

interface IMdfOverviewCardProps {
  title: string
  titleTooltip?: string
  value: ReactNode
  footer?: ReactNode
  className?: string
  replaceParams?: TReplaceOptions[]
}

export const MdfOverviewCard: FC<IMdfOverviewCardProps> = ({
  title,
  titleTooltip,
  value,
  footer,
  className,
  replaceParams,
}) => {
  return (
    <div className={classNames(styles.root, className)}>
      <Flex className={styles.title} alignItems="center" gap="xs">
        <Translation text={title} replaceParams={replaceParams} span />
        {titleTooltip && (
          <Tooltip inline tipContent={() => <Translation text={titleTooltip} span />}>
            <i
              className={classNames('kbase kbase-info', styles.titleInfoIcon)}
              aria-hidden="true"
            />
          </Tooltip>
        )}
      </Flex>

      <div className={styles.value}>{value}</div>

      {footer ? <div className={styles.footer}>{footer}</div> : null}
    </div>
  )
}

MdfOverviewCard.displayName = 'MdfOverviewCard'
